import { COVERGO_SAAS_DEV, COVERGO_CA_UAT } from "../consts.js"

export const pbc_dev = {
	"pbc-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "pbc_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV,
		fileSystem: {
			bucketName: "covergo-apse1-dev-pbc-dev"
		}
	}
}

export const pbc_uat = {
	"pbc-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "pbc_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-pbc-uat"
		}
	},
}

